import { render } from "./ModalFormProvincia.vue?vue&type=template&id=c029b932&scoped=true"
import script from "./ModalFormProvincia.vue?vue&type=script&lang=js"
export * from "./ModalFormProvincia.vue?vue&type=script&lang=js"

import "./ModalFormProvincia.vue?vue&type=style&index=0&id=c029b932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c029b932"]])

export default __exports__